var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height"},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"text-center"},[_c('h2',[_vm._v("Page Not Found")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }